import { useEffect, useState } from 'react';
import { useUiStore } from '../store/uiStore';

/**
 * Поважаємо і системну налаштування, і власний перемикач у застосунку.
 * Достатньо будь-якого з двох — важкі анімації вимикаються.
 */
export function useReducedMotion(): boolean {
  const manual = useUiStore((s) => s.reducedMotion);
  const [system, setSystem] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setSystem(mq.matches);
    const handler = (event: MediaQueryListEvent): void => setSystem(event.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return manual || system;
}
